import styled from 'styled-components';
import { Wrapper } from 'AppReact';

const template = styled.div`
  width: 100%;
  border: 1px solid #E3E3E3;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  margin-top: 12px;

  @media only screen and (min-width: 768px) {
    margin-top: 0px;
    border: none;
    border-radius: 0px;
    border-bottom: 1px solid #E7EBEB;
  }
`;


export default Wrapper(template)